/* exported initGridColorSwatches*/

function initGridColorSwatches() {
	const colorSwatchContainers = document.querySelectorAll('.grid-product-colors');
	if (!colorSwatchContainers.length) {
		return;
	}
	colorSwatchContainers.forEach((container) => container.addEventListener('click', handleColorPick, true));
}
initGridColorSwatches();

function handleColorPick(e) {
	const button = e.target.closest('button');
    if (!button || !button.classList.contains('sibling-product')) {
        return;
    }
	const colorSwatch = button;
	const { productPrice, productUrl, selectedTitle, productMainImage } = colorSwatch.dataset;

	const product = button.closest('product-item');
	
	const productTitleElement = product.querySelector('.product-item-meta__title');
	productTitleElement.textContent = selectedTitle;
	
	const productMainImageElement = product.querySelector('.product-item__primary-image');
	productMainImageElement.srcset = productMainImage;

	const productOriginPriceSpan = product.querySelector(
		'.product-item__info .price-list .price'
	);
	const priceList = productOriginPriceSpan.closest('.price-list');
	priceList.innerHTML = '';
	productOriginPriceSpan.textContent = productPrice;
	priceList.appendChild(productOriginPriceSpan);
	
	// Toggles the 'is-selected' class between color swatches to update the currently selected color.
	product.querySelector('.product-item__info .current-product')?.classList.remove('current-product');
	colorSwatch.classList.add('current-product');

	// Handle the switching of secondary images for a product based on the selected color swatch.
	const productLinkElement = product.querySelector('.product-item-link');
	productLinkElement.href = productUrl;
	secondaryImageSwitch(product, colorSwatch, productLinkElement);

	// Handle the compared price for a color swatch and updates the price list and original price span accordingly.
	comparedPriceHandler(colorSwatch, priceList, productOriginPriceSpan);

	// Updates the discount label for a product based on the selected color swatch.
	updateDiscountLabel(product, colorSwatch);

	// // Handles the drawer and popover URLs for a product based on the product URL.
	drawerAndPopoverHandler(product, productUrl);
	

}

function secondaryImageSwitch(product, colorSwatch, productLinkElement) {
	// Find the images wrapper element within the product
	const imagesWrapper = product.querySelector('.product-item__image-wrapper');

	// Remove the unnecessary secondary image and associated class
	imagesWrapper.classList.remove('product-item__image-wrapper--multiple');
	imagesWrapper.querySelector('.product-item__secondary-image')?.remove();

	// Check if the current color swatch has a secondary image attribute
	const isCurrentColorSwatchHasSecondaryImage = colorSwatch.getAttribute(
		'data-product-secondary-image'
	);
	// If the current color swatch has a secondary image
	if (isCurrentColorSwatchHasSecondaryImage) {
		// Create a new secondary image element and append it to the images wrapper
		createSecondaryImage(imagesWrapper, productLinkElement, colorSwatch.dataset.productSecondaryImage);
	}
}

function createSecondaryImage(imagesWrapper, productLinkElement, productSecondaryImage) {
	// Add class for multiple images to the images wrapper
	imagesWrapper.classList.add('product-item__image-wrapper--multiple');

	// Create a new secondary image element
	const newSecondaryImage = document.createElement('img');
	newSecondaryImage.srcset = productSecondaryImage;
	newSecondaryImage.classList.add('product-item__secondary-image');

	// Append the new secondary image to the product link element
	productLinkElement.appendChild(newSecondaryImage);
}

function comparedPriceHandler(colorSwatch, priceList, productOriginPriceSpan) {
	// Check if the current color swatch is in sale
	const isCurrentColorSwatchInSale = colorSwatch.getAttribute('data-in-sale');

	// If the current color swatch is not in sale, remove the highlight class from the original price span
	if (isCurrentColorSwatchInSale === 'false') {
		return productOriginPriceSpan.classList.remove('price--highlight');
	}

	// Create a new element for the erased price
	const newErasedPrice = document.createElement('span');
	newErasedPrice.classList.add('price', 'price--compare');
	newErasedPrice.textContent = colorSwatch.dataset.productComparePrice;

	// Add the highlight class to the original price span
	productOriginPriceSpan.classList.add('price--highlight');

	// Append the erased price element to the price list
	priceList.appendChild(newErasedPrice);
}

function updateDiscountLabel(product, colorSwatch) {
	// Check if the current color swatch has a save amount attribute
	const productHasSaveAmount = colorSwatch.getAttribute('data-product-save-amount');

	// Find the images wrapper element within the product
	const imagesWrapper = product.querySelector('.product-item__image-wrapper');

	// If the current color swatch has no save amount, remove the discount label
	if (!productHasSaveAmount) {
		return imagesWrapper.querySelector('.product-item__label-list')?.remove();
	}
	// Check if a discount label already exists in the images wrapper
	let discountLabel = imagesWrapper.querySelector('.product-item__label-list');

	// If no discount label exists, create a new one and append it to the images wrapper
	if (!discountLabel) {
		discountLabel = document.createElement('div');
		discountLabel.classList.add('product-item__label-list', 'label-list');
		imagesWrapper.appendChild(discountLabel);
	}

	// Check if a label with the highlight class exists in the discount label
	let label = discountLabel.querySelector('.label--highlight');
	if(!label) {
		label = document.createElement('span');
		label.classList.add('label', 'label--highlight');
	}
	label.textContent = window.themeVariables.strings.collectionDiscount.replace(
		'@savings@',
		colorSwatch.dataset.productSaveAmount
	);
	discountLabel.appendChild(label);
}

function drawerAndPopoverHandler(product, productUrl) {
	// Determine the query char to use based on whether the URL already contains a query string
	const queryChar = productUrl.includes('?') ? '&' : '?';

	// Generate the URLs for the quick buy drawer and popover
	const quickBuyDrawerUrl = productUrl + queryChar + 'view=quick-buy-drawer';
	const quickBuyPopoverUrl = productUrl + queryChar + 'view=quick-buy-popover';

	// Set the href attribute of the quick buy drawer and popover elements
	product.querySelector('quick-buy-drawer').setAttribute('href', quickBuyDrawerUrl);
	product.querySelector('quick-buy-popover').setAttribute('href', quickBuyPopoverUrl);
}